import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-24 px-4 bg-[#0f0f0f] relative border-t border-neutral-800" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-95">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-10 leading-tight" data-id="element-96">
            Tu Esfuerzo No Es el Problema. <br className="hidden md:block" data-id="element-97" />
            <span className="text-[#C9A84C]" data-id="element-98">Tu Moneda Sí Lo Es.</span>
          </h2>

          <div className="space-y-8 text-lg md:text-xl text-[#D1D5DB] leading-relaxed" data-id="element-99">
            <p data-id="element-100">
              Imagina que trabajas 40 horas a la semana, pero cada mes tu renta,
              la comida y el transporte suben. Sientes{' '}
              <span className="text-[#C9A84C] font-semibold" data-id="element-101">
                rabia, frustración, y un poco de miedo
              </span>
              . No es tu culpa, es la moneda que se devalúa sin que puedas hacer
              nada.
            </p>

            <p className="text-xl md:text-2xl font-medium text-white" data-id="element-102">
              <span className="text-[#1A7A4A] font-bold" data-id="element-103">$1000 USD</span> para
              un americano es poco.{' '}
              <span className="text-[#C9A84C] font-bold" data-id="element-104">
                Para LATAM puede cambiar tu mes.
              </span>
            </p>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3,
            duration: 0.5
          }} className="my-12 p-8 rounded-2xl bg-[#0A0A0A] border border-[#C9A84C]/20 shadow-[0_0_30px_rgba(201,168,76,0.05)] relative overflow-hidden" data-id="element-105">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#C9A84C]" data-id="element-106" />
              <p className="text-2xl md:text-3xl font-bold text-[#C9A84C] italic text-center" data-id="element-107">
                "Ganar en pesos es como llenar un balde con agujeros."
              </p>
            </motion.div>

            <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.6
          }} className="text-2xl font-bold text-white text-center mt-12" data-id="element-108">
              Pero hay una salida...
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>;
}